// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { Interview, InterviewEvaluation } from '../types';
import { createQueryKey } from '../utils/keys';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const postInterviewEvaluationMutationKey = [
  'postInterviewEvaluation',
] as const;
export const putEvaluationsMutationKey = ['putEvaluations'] as const;
export const deleteEvaluationMutationKey = ['deleteEvaluation'] as const;
export const updateInterviewMutationKey = ['updateInterview'] as const;
export const createInterviewMutationKey = ['createInterview'] as const;
export const deleteInterviewMutationKey = ['deleteInterview'] as const;
export const generateInterviewAiMutationKey = ['generateInterviewAi'] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getEvaluationsQueryKey = (
  workspaceId: number,
  openingId: number,
  candidateId: number,
  interviewId: number
) =>
  createQueryKey<InterviewEvaluation[]>()([
    'workspaces',
    workspaceId,
    'openings',
    openingId,
    'candidates',
    candidateId,
    'interviews',
    interviewId,
    'evaluations',
  ] as const);

export const getInterviewQueryKey = (
  workspaceId: number,
  openingId: number,
  stageId: number
) =>
  createQueryKey<Interview>()([
    'workspaces',
    workspaceId,
    'openings',
    openingId,
    'stages',
    stageId,
    'interview',
  ] as const);
